import React, {useState} from "react";
import Button from "../../Buttons/Button/Button";
import { validateContactForm } from "./ContactFormValidation";
import "./ContactForm.scss";
import ".././Form.scss";
import {submitContactForm} from "../../../services/api/submitFormToApi";


const ContactForm = () => {
    const [errors, setErrors] = useState({});
    const [submitStatus, setSubmitStatus] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [apiError, setApiError] = useState('');



    const handleContactFormSubmit = async (event) => {
        event.preventDefault();
        const form = event.target;
        const validationErrors = validateContactForm(form);

        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            setSubmitStatus('');
            setApiError('');
            return;
        }

        setErrors({});
        setApiError('');
        setIsLoading(true);

        try {
            const formData = new FormData(form);
            const formDataObject = Object.fromEntries(formData.entries());

            const response = await submitContactForm(formDataObject);

            if ('data' in response && response.data.success) {
                setSubmitStatus('success');
                form.reset();
                setTimeout(() => setSubmitStatus(''), 5000);
            } else if ('error' in response) {
                setSubmitStatus('error');
                setApiError(response.error.message);
            }
        } catch (error) {
            setSubmitStatus('error');
            setApiError(error.message || 'Wystąpił nieoczekiwany błąd podczas wysyłania formularza.');
        } finally {
            setIsLoading(false);
        }

    };

    return (
        <div className="contact-form">
            <div className="contact-form--inside">
                <form className="form send-contact-form" id="send-contact-form" onSubmit={handleContactFormSubmit}>

                    {/* Informacje o wysyłce formularza */}
                    {apiError && (
                        <div className="alert-message error-message">
                            <div className="alert alert-danger">
                                {apiError}
                            </div>
                        </div>
                    )}

                    {submitStatus === 'success' && (
                        <div className="alert-message success-message">
                            <div className="alert alert-success">
                                Formularz został wysłany pomyślnie!
                            </div>
                        </div>
                    )}

                    {/* Name and Surname */}
                    <div className="form-group name-form-row">
                        <div className="form-group--inside">
                            <label htmlFor="name_surname">Imię i nazwisko*</label>
                            <input type="text" id="name_surname" name="name_surname" placeholder="Imię i nazwisko"/>
                            {errors.name_surname && <span className="error">{errors.name_surname}</span>}
                        </div>
                    </div>

                    {/* Phone */}
                    <div className="form-group phone-form-row">
                            <div className="form-group--inside">
                                <label htmlFor="phone">Telefon*</label>
                                <input type="tel" id="phone" name="phone" placeholder="Podaj telefon"/>
                                {errors.phone && <span className="error">{errors.phone}</span>}
                            </div>
                    </div>

                    {/* Email */}
                    <div className="form-group email-form-row">
                            <div className="form-group--inside">
                                <label htmlFor="email">Email*</label>
                                <input type="email" id="email" name="email" placeholder="Podaj email"/>
                                {errors.email && <span className="error">{errors.email}</span>}
                            </div>
                    </div>

                    {/* Project Description */}
                    <div className="form-group description-form-row">
                            <div className="form-group--inside">
                                <label htmlFor="project_description">Opis projektu *</label>
                                <textarea
                                    id="project_description"
                                    name="project_description"
                                    placeholder="Opisz krótko swój projekt, cele, branżę i grupę docelową"
                                    required
                                ></textarea>
                                {errors.project_description &&
                                    <span className="error">{errors.project_description}</span>}
                            </div>
                    </div>

                    {/* RODO DESCRIPTION */}
                    <div className="form-group description-form-row rodo-text">
                        <span>
                        Wypełniając i przesyłając formularz niniejszym wyraża Pani/Pan zgodę na przetwarzanie swoich
                            danych osobowych przez Agencje Interaktywną Siteart.pl jako administratora danych zgodnie
                            z ustawą z dnia 29 sierpnia 1997 r. o ochronie praw osobowych (Dz. U. z 2016 r. poz. 922 ze zm.)
                            oraz rozporządzeniem Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r.
                            w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie
                            swobodnego przepływu takich danych oraz uchylenia dyrektywy
                            95/46/WE (Dz. U. UE. L. z 2016 r. Nr 119) zwanego „RODO”.
                        </span>
                    </div>

                    {/* Submit Button */}
                    <div className="form-group submit-form-row">
                            <div className="form-group--inside">
                                <Button
                                    classes={[
                                        "btn",
                                        "btn-submit",
                                        "btn-contact-form",
                                        "btn-form",
                                        "left-to-right-animate",
                                        "blue-to-black",
                                        isLoading ? "loading" : ""
                                    ]}
                                    text={isLoading ? 'Wysyłanie...' : 'Wyślij'}
                                    hasIcon={false}
                                    type="submit"/>
                            </div>
                        </div>

                </form>
            </div>
        </div>
    )
}

export default ContactForm;